import { SetStateAction } from 'react';
import isStringDefined from '../is-string-defined';

const handleSearchQuery = (
  query: string,
  search: (arg0: string) => void,
  setShowResult?: (value: SetStateAction<boolean>) => void
) => {
  if (isStringDefined(query)) {
    if (setShowResult) {
      setShowResult(true);
    }
    search(query);
  } else {
    if (setShowResult) {
      setShowResult(false);
    }
  }
};

export default handleSearchQuery;
